import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function autocompleteValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (typeof value === 'string' && value.trim()) {
        return null
      }
      if (typeof value === 'object' && value && (value.key || value.value)) {
        return null;
      }
      if (typeof value === 'object' && value && (value.id || value.name)) {
        return null;
      }
      return { required: true, autocompleteRequired: true };
    };
}
